import Vue from 'vue'
//import Vuetify from 'vuetify/lib'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)
import '../styles/default.styl'

export default new Vuetify({
  customVariables: ['~/styles/default.styl'],
  theme: {
    themes: {
      light: {
        primary:  "#FFFFFF", // #E53935
        secondary: "#718CD1", // #FFCDD2
        accent: "#718CD1", // #3F51B5
      },
      dark: {
        primary: "#000000",
        secondary: "#718CD1", // #FFCDD2
        accent: "#718CD1", // #3F51B5
      }
    },
  },
})